import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { Field, Fields } from "redux-form";
import { ALTERNATE_TYPES, ALTERNATES } from "MODULES/parts/constants";
import { Form as AppForm, Select } from "MODULES/shared/components/Forms";
import Search from "./Search";

const option = (value, text) => ({ value, text });
const options = ALTERNATE_TYPES.map(t => option(t, ALTERNATES[t].label));

export default function Form(props) {
  const showPartInput = _.get(props, "showPartInput", true);

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Field
          name="alternate_type"
          component={Select}
          label="Type"
          options={options}
          required
        />
        {showPartInput && (
          <Fields names={["alternate_part_id", "label"]} component={Search} />
        )}
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  showPartInput: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/Alternates/Form.jsx